/** When your routing table is too long, you can split it into small modules**/

// 系统管理

import Layout from '@/views/layout/Layout'

const mtBaiduMapManage = {
  path: '/mtBaiduMapManage',
  component: Layout,
  alwaysShow: true,
  name: '数据看板',
  redirect: 'noredirect',
  meta: {
    title: '数据看板',
    icon: 'list',
    resources: 'mtBaiduMapManage'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/baidumap/index'),
      name: '数据驾驶舱',
      meta: { title: '数据驾驶舱', icon: 'chart', noCache: true, resources: 'accountList' }
    }

  ]
}

export default mtBaiduMapManage
